<template>
  <application-layout>
    <v-main>
      <v-container>
        <validation-observer
          ref="createCategoryForm"
          v-slot="{ invalid }"
        >
          <h1>Create Help Center Category</h1>
          <div class="mt-2">
            <h2 class="my-6">Text</h2>
            <app-input
              data-testid="help-category-create-name-input"
              class="help-category-create-name-input"
              :type="'text'"
              hint="Enter the category name"
              v-model.trim="category.name"
              label="Category name"
              :rules="{ required: true }"
              :useValidation="true"
            />
            <app-textarea
              data-testid="help-category-create-description-textarea"
              class="help-category-create-description-textarea"
              filled
              hint="Type a description for this category"
              v-model.trim="category.description"
              clearable
              auto-grow
              rows="1"
              label="Description"
              counter="512"
              :rules="{ required: true, max: 512 }"
              :useValidation="true"
              :type="'text'"
            />
            <h2 class="my-4">URL</h2>
            <app-input
                data-testid="help-category-create-slug-input"
                class="help-category-create-slug-input"
                :type="'text'"
                hint="The relative path used to browse this category on the main site."
                v-model.trim="category.slug"
                label="Slug"
                :rules="{ required: true, slug: true }"
                :useValidation="true"
            />
            <v-row class="pr-3">
              <v-spacer />
              <v-btn
                data-testid="help-category-create-cancel-btn"
                class="error help-category-create-cancel-btn ml-0 mr-3"
                @click="() => { $router.back(); }"
              >
                Cancel
              </v-btn>
              <v-btn
                data-testid="help-category-create-submit-btn"
                class="help-category-create-submit-btn"
                color="primary"
                @click="submitForm"
                :loading="loadingState.includes('creating help center category')"
                :disabled="invalid"
              >
                Create
              </v-btn>
            </v-row>
          </div>
        </validation-observer>
      </v-container>
    </v-main>
  </application-layout>
</template>

<script>
import AppInput from "@/components/global/AppInput.vue";
import AppTextarea from "@/components/global/AppTextarea.vue";
import ApplicationLayout from "@/layouts/ApplicationLayout.vue";
import Mixins from "../mixins.js";
import { ValidationObserver } from "vee-validate";

export default {

  mixins: [Mixins],

  computed: {
    category: {
      get() {
        return this.$store.getters["helpCenter/currentCategory"];
      },
      set(newValue) {
        return this.$store.commit("helpCenter/setCurrentCategory", newValue);
      }
    },
    loadingState() {
      return this.$store.getters["helpCenter/loadingState"];
    }
  },

  methods: {
    submitForm() {
      if (this.$refs.createCategoryForm.validate()) {
        this.$store.dispatch("helpCenter/createCategory", this.category)
          .then(() => {
            this.$store.dispatch("helpCenter/getAllCategories");
            this.$router.push({
              name: "helpCenterCategories"
            });
          });
      }
    }
  },

  components: {
    ApplicationLayout,
    AppInput,
    AppTextarea,
    ValidationObserver
  },

  created() {
    this.$store.commit("helpCenter/resetCurrentCategory");
  }
};
</script>
